import { createAction } from 'redux-actions';
import {
  CREATE_PREVIEW_THUMBNAIL,
  END_THUMBNAIL_GENERATION,
  START_THUMBNAIL_GENERATION,
  SYNC_PREVIEW_THUMBNAIL,
} from '../constants/actions';

export const createPreviewThumbnail = createAction(CREATE_PREVIEW_THUMBNAIL);

export const syncPreviewThumbnail = createAction(SYNC_PREVIEW_THUMBNAIL);

export const startThumbnailGeneration = createAction(
  START_THUMBNAIL_GENERATION,
);

export const endThumbnailGeneration = createAction(END_THUMBNAIL_GENERATION);
